import { Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { SectionModal } from './section-modals/SectionModal';
import { useCourseView } from './useCourseView';
import { Item, Section } from 'src/@types/Course';
import { SectionSummery } from './Section-Summery/SectionSummery';
import { SectionItemModal } from './section-modals/SectionItemModal';
import { useState } from 'react';
import { StyledTextMaxLine } from './styles';
import ConfirmationDialog from './section-item-table/ConformiationDialog';
import { TableNoData } from 'src/components/table';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function CourseItem() {
  const {
    onSubmitNewSection,
    onSubmitNewSectionItem,
    sectionModalOpen,
    setCurrentSection,
    SetSectionModalOpen,
    currentCourse,
    currentSection,
    onDeleteSection,
    onDeleteItem,
    modalOpen,
    setModalOpen,
    modalStep,
    setModalStep,
    currentItem,
    setCurrentItem,
    onGoUpDown,
  } = useCourseView();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [expanded, setExpanded] = useState<string | false>(false);
  const navigate = useNavigate();

  return (
    <Stack>
      <HeaderBreadcrumbs
        heading={currentCourse?.name as string}
        links={[
          { name: 'Dashboard', href: PATH_DASHBOARD.root },
          { name: 'Course List', href: PATH_DASHBOARD.courses.root },

          {
            name: currentCourse?.name as string,
            href: PATH_DASHBOARD.courses.view(currentCourse?.id as string),
          },
        ]}
        action={
          <Stack direction="row" spacing={1.5}>
            <Button
              variant="outlined"
              onClick={() =>
                navigate(`${PATH_DASHBOARD.courses.view(currentCourse?.id as string)}/report`)
              }
              startIcon={<Iconify icon={'eva:bar-chart-2-outline'} />}
            >
              Report
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setCurrentSection(undefined);
                SetSectionModalOpen(true);
              }}
              startIcon={<Iconify icon={'eva:plus-fill'} />}
            >
              New Section
            </Button>
          </Stack>
        }
      />
      <StyledTextMaxLine>{'Section Items'}</StyledTextMaxLine>
      {currentCourse?.sections.map((item, index) => (
        <SectionSummery
          expanded={expanded}
          setExpanded={setExpanded}
          onDeleteItem={(index, sectionIndex) => onDeleteItem(index, sectionIndex)}
          onGoUpDown={(fromIndex:number,toIndex:number) => {
            setCurrentSection({ section: item, index: index });
            onGoUpDown(fromIndex, toIndex);
          }}
          setModalOpen={setModalOpen}
          setCurrentItem={setCurrentItem}
          sectionIndex={index}
          setCurrentSection={(section: Section, index: number) => {
            setCurrentSection({ section: section, index: index });
          }}
          SetSectionModalOpen={SetSectionModalOpen}
          onDeleteSection={() => {
            setCurrentSection({ index: index, section: item });
            setConfirmOpen(true);
          }}
          key={index}
          section={item}
        />
      ))}
      {!currentCourse?.sections ||
        (currentCourse?.sections?.length === 0 && (
          <Stack
            sx={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <TableNoData isNotFound={true} />
          </Stack>
        ))}

      <SectionModal
        onSubmit={onSubmitNewSection}
        currentSection={currentSection?.section}
        handleClose={() => SetSectionModalOpen(false)}
        isEdit={currentSection ? true : false}
        open={sectionModalOpen}
      />
      <SectionItemModal
        currentItem={currentItem?.item}
        handleClose={() => {
          setModalOpen(false);
          setCurrentItem(undefined);
          setModalStep(0);
        }}
        isEdit={currentItem ? true : false}
        onSubmit={(data) => {
          console.log('dataaa', data);
          onSubmitNewSectionItem(data, currentItem ? currentItem.index : undefined);
        }}
        modalStep={modalStep}
        setModalStep={setModalStep}
        open={modalOpen}
      />
      <ConfirmationDialog
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        confirmAction={onDeleteSection}
        loading={false}
      />
    </Stack>
  );
}
